
/* styles */
require("!!../../../../../../Users/vbastos/AppData/Roaming/npm/node_modules/front-cli/node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":0,\"remove\":true,\"publicPath\":\"../\"}!css-loader?{\"sourceMap\":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-0aa867a8\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./home.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-0aa867a8\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./home.vue"),
  /* scopeId */
  "data-v-0aa867a8",
  /* cssModules */
  null
)
Component.options.__file = "C:\\Repositorios\\AGENDA_PREFEITO\\front-end\\application\\views\\commons\\home.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] home.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0aa867a8", Component.options)
  } else {
    hotAPI.reload("data-v-0aa867a8", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./application/views/commons/home.vue
// module id = 330
// module chunks = 1